import React from "react"
import PropTypes from "prop-types"

import styles from "./sizing-wrapper.module.scss"

const SizingWrapper = ({ height, width, children }) => {
  return (
    <div className={styles.sizingWrapper} style={{ height, width }}>
      {React.Children.only(children)}
    </div>
  )
}

SizingWrapper.defaultProps = {
  height: "100%",
  width: "100%",
}

SizingWrapper.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default SizingWrapper
